import logoSrc from '@/assets/logo.svg';

interface LogoProps {
  variant?: 'dark' | 'light';
  height?: number;
  className?: string;
}

/**
 * Den Dagen logo.
 * variant="dark"  → mørk logo (til lys bakgrunn, standard)
 * variant="light" → lys logo (til mørk/navy bakgrunn)
 */
export default function Logo({ variant = 'dark', height = 32, className = '' }: LogoProps) {
  const aspectRatio = 214 / 73;
  const width = height * aspectRatio;

  return (
    <img
      src={logoSrc}
      alt="Den Dagen"
      height={height}
      width={width}
      className={className}
      style={variant === 'light' ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
  );
}
